export const iconFontAwesomeSocialUsers = (
	<i className="fa-solid fa-users"></i>
);
